/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Group_BrewInputs */

const vi_shop_group_brew = /** @type {(inputs: Shop_Group_BrewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cách pha`)
};

/**

* @param {Shop_Group_BrewInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_group_brew = /** @type {((inputs?: Shop_Group_BrewInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Group_BrewInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_group_brew(inputs)
});